import { isNumber } from 'lodash-es'

export const getExternalImageURL = ({
  src,
  width,
  height,
  bucket = process.env.NEXT_PUBLIC_CLOUDFRONT_BUCKET,
}: {
  src: string
  width?: number | null
  height?: number | null
  bucket?: string
}) => {
  const sizeParameter =
    isNumber(width) && isNumber(height) ? `&d=${width}x${height}` : ''

  return `https://${process.env.NEXT_PUBLIC_CLOUDFRONT_URL}/${src}?b=${bucket}${sizeParameter}`
}
